<template>
	<vx-card class="mb-1" id="fliterCard">
		<div class="vx-row justify-between">
			<div class="vx-row">
				<div
					class="vx-col"
					v-if="$props.isFilterButton"
					@click="toogleFilter()"
				>
					<vs-button
						type="filled"
						class="btn"
						icon-pack="feather"
						icon-after
						:icon="showFilters ? 'icon-chevron-down' : 'icon-chevron-right'"
						>Filtres</vs-button
					>
				</div>
				<div class="vx-col" :key="action.order" v-for="action in actions">
					<div>
						<vs-button
							v-if="!action.buttonIcon"
							@click="
								handleEmitEvent('action', { emitSlugName: action.emitSlugName })
							"
							:color="action.buttonColor"
							>{{ action.buttonName }}</vs-button
						>
						<vs-button
							v-else
							icon-pack="feather"
							:icon="action.buttonIcon"
							@click="
								handleEmitEvent('action', { emitSlugName: action.emitSlugName })
							"
							:color="action.buttonColor"
							>{{ action.buttonName }}</vs-button
						>
					</div>
				</div>
			</div>
			<div>
				<div key="workLoadKey" v-if="showProspectStatus">
					<div v-if="workLoad">
						<vx-tooltip
							:text="formattedWorkLoad()"
							position="top"
							style="text-align: -webkit-center; margin-right: 0 !important"
						>
							<vs-avatar color="success" text=" " />
						</vx-tooltip>
					</div>
					<vs-avatar v-else color="danger" text=" " />
				</div>
			</div>
		</div>
		<br />
		<div
			v-if="showFilters"
			class="vx-row flex justify-between"
			style="padding-left: 9px"
		>
			<div class="vx-row flex-1">
				<div
					:key="filter.order"
					v-for="filter in filtersValues"
					class="vx-col py-2 px-1"
				>
					<span v-if="filter.type == 'Dropdown'">
						<vs-select
							v-model="filter.value"
							class="w-full select-large"
							:placeholder="filter.filterPlaceHolder"
							:autocomplete="filter.params.autocomplete"
							:multiple="filter.params.multiple"
							@change="
								handleEmitEvent('filter', {
									emitSlugName: filter.emitSlugName,
									params: { value: filter.value },
								})
							"
						>
							<vs-select-item
								value=""
								:text="filter.filterPlaceHolder"
								class="w-full"
							/>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="
									filter.params.valueField
										? item[filter.params.valueField]
										: item.name
								"
								v-for="(item, index) in filter.params.dropdownValues"
								class="w-full"
							/>
						</vs-select>
					</span>
					<span v-if="filter.type == 'PaperClubDropdown'">
						<vs-select
							v-model="filter.value"
							class="w-full select-large"
							:placeholder="filter.filterPlaceHolder"
							:autocomplete="filter.params.autocomplete"
							:multiple="filter.params.multiple"
							@change="
								handleEmitEvent('filter', {
									emitSlugName: filter.emitSlugName,
									params: { value: filter.value },
								})
							"
						>
							<vs-select-item
								value=""
								:text="filter.filterPlaceHolder"
								class="w-full"
							/>
							<vs-select-item
								:key="index"
								:value="item.name"
								:text="
									filter.params.valueField
										? item[filter.params.valueField]
										: item.name
								"
								v-for="(item, index) in filter.params.dropdownValues"
								class="w-full"
							/>
						</vs-select>
					</span>
					<span v-if="filter.type == 'Date'">
						<!-- Period picker with arrow buttons -->
						<div
							v-if="isGestion && showPeriodArrows"
							class="ml-5"
							style="display: flex; align-items: center; gap: 8px"
						>
							<vs-button
								size="small"
								color="primary"
								type="border"
								icon-pack="feather"
								icon="icon-chevron-left"
								@click="gotoPreviousMonth"
								style="min-width: 32px; padding: 4px"
							></vs-button>

							<vx-input-group class="w-full bottom" style="flex: 1">
								<template slot="prepend">
									<div class="prepend-text bg-primary">
										<span class="flex"
											><vs-icon icon="calendar_today" size="small"></vs-icon
										></span>
									</div>
								</template>
								<div :key="datePickerKey">
									<month-picker-input
										:max-date="maxDate"
										:default-year="thisYear"
										:default-month="thisMonth"
										:no-default="false"
										lang="fr"
										@input="showDate"
									/>
								</div>
							</vx-input-group>

							<vs-button
								size="small"
								color="primary"
								type="border"
								icon-pack="feather"
								icon="icon-chevron-right"
								@click="gotoNextMonth"
								:disabled="isCurrentPeriod"
								style="min-width: 32px; padding: 4px"
							></vs-button>
						</div>

						<!-- Regular input group without arrows -->
						<vx-input-group v-else class="w-full bottom">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span class="flex"
										><vs-icon icon="calendar_today" size="small"></vs-icon
									></span>
								</div>
							</template>
							<div v-if="isGestion" :key="datePickerKey">
								<month-picker-input
									:max-date="maxDate"
									:default-year="thisYear"
									:default-month="thisMonth"
									:no-default="false"
									lang="fr"
									@input="showDate"
								/>
							</div>
							<div v-else>
								<flat-pickr
									class="w-full"
									v-if="filter.require"
									v-model="filter.value"
									:placeholder="filter.filterPlaceHolder"
									:config="
										filter.params.date_type == 'period'
											? configPeriodPicker
											: configDatePicker
									"
									@input="
										handleEmitEvent('filter', {
											emitSlugName: filter.emitSlugName,
											params: { value: filter.value },
										})
									"
									@keydown.native.delete.capture.stop.prevent
								/>
								<flat-pickr
									class="w-full"
									v-else
									v-model="filter.value"
									:placeholder="filter.filterPlaceHolder"
									:config="
										filter.params.date_type == 'period'
											? configPeriodPicker
											: configDatePicker
									"
									@input="
										handleEmitEvent('filter', {
											emitSlugName: filter.emitSlugName,
											params: { value: filter.value },
										})
									"
									@keydown.native.delete.capture.stop.prevent
								/>
							</div>
							<!--

					<template slot="append">
						<div class="append-text"
						style="background-color:white; color: #A9A9A9; cursor: pointer;"
						v-on:click="dateClear()"
						>
						<span class="flex"
							><vs-icon icon="clear" size="small"></vs-icon
						></span>
						</div>
					</template> -->
						</vx-input-group>
					</span>
					<span v-if="filter.type == 'Input'">
						<vs-input
							class="inputx"
							:placeholder="filter.filterPlaceHolder"
							v-model="filter.value"
							@input="
								handleEmitEvent('filter', {
									emitSlugName: filter.emitSlugName,
									params: { value: filter.value },
								})
							"
						/>
					</span>
					<span v-if="filter.type == 'Switch'">
						<vs-switch
							color="primary"
							v-model="filter.value"
							@change="
								handleEmitEvent('filter', {
									emitSlugName: filter.emitSlugName,
									params: { value: filter.value },
								})
							"
						>
							<span slot="on">{{ filter.params.on }}</span>
							<span slot="off">{{ filter.params.off }}</span>
						</vs-switch>
					</span>
					<span v-if="filter.type == 'Tag'">
						<vue-tags
							class="tag-filter"
							placeholder="Tags"
							:active="filter.params.domainFilter"
							:all="filter.params.activityDomainOptions"
							:tag-creation-enabled="true"
							tag-list-label=""
							@on-tag-added="
								onTagAdded($event, filter);
								handleEmitEvent('filter', {
									emitSlugName: filter.emitSlugName,
									params: { value: filter.params.domainFilter },
								});
							"
							@on-tag-removed="
								onTagRemoved($event, filter);
								handleEmitEvent('filter', {
									emitSlugName: filter.emitSlugName,
									params: { value: filter.params.domainFilter },
								});
							"
							@on-tag-list-opened="
								tagStyle =
									'z-index: 1600 !important; width: 400px !important; overflow: visible;'
							"
							@on-tag-list-closed="
								tagStyle =
									'z-index: 1600 !important; width: 400px !important; overflow: auto;'
							"
							:style="tagStyle"
						>
						</vue-tags>
					</span>
					<span v-if="filter.type == 'Slider'">
						<div
							class="switch-toggle switch-3 switch-candy switch-candy-blue"
							style="top: 10%"
						>
							<input
								id="activeFilteroff"
								name="activeFilterstate-d"
								type="radio"
								checked=""
								value="0"
								v-model="filter.value"
							/>
							<label
								for="activeFilteroff"
								@click="
									handleEmitEvent('filter', {
										emitSlugName: filter.emitSlugName,
										params: { value: 0 },
									})
								"
								>{{ filter.params.off }}</label
							>

							<input
								id="activeFilternull"
								name="activeFilterstate-d"
								type="radio"
								checked="checked"
								value=""
								v-model="filter.value"
							/>
							<label
								for="activeFilternull"
								class="disabled"
								@click="
									handleEmitEvent('filter', {
										emitSlugName: filter.emitSlugName,
										params: { value: '' },
									})
								"
								>{{ filter.params.default }}</label
							>

							<input
								id="activeFilteron"
								name="activeFilterstate-d"
								type="radio"
								value="1"
								v-model="filter.value"
							/>
							<label
								for="activeFilteron"
								@click="
									handleEmitEvent('filter', {
										emitSlugName: filter.emitSlugName,
										params: { value: 1 },
									})
								"
								>{{ filter.params.on }}</label
							>

							<a></a>
						</div>
					</span>
					<span v-if="filter.type == 'Btn'">
						<vs-button
							@click="
								handleEmitEvent('filter', {
									emitSlugName: filter.emitSlugName,
									params: { value: true },
								})
							"
							color="primary"
							>Rechercher</vs-button
						>
					</span>
				</div>
				<div>
					<vx-tooltip
						text="Effacer les filtres"
						position="top"
						style="text-align: -webkit-center; margin-right: 0 !important"
					>
						<vs-button
							v-if="del"
							class="ml-2"
							type="line"
							style="border: 0px"
							@click="clearAll()"
							color="danger"
							icon="clear"
						></vs-button>
					</vx-tooltip>
				</div>
			</div>
			<div class="flex justify-center items-center flex-2">
				<span v-if="sortBacklinks">
					Tirer par:
					<select
						v-model="selectedOption"
						@change="
							handleEmitEvent('filter', {
								emitSlugName: sortBacklinks.emitSlugName,
								params: { value: selectedOption },
							})
						"
					>
						<option
							v-for="option in backlinksSortType"
							:key="option.id"
							:value="option.id"
						>
							{{ option.label }}
						</option>
					</select>
				</span>
			</div>
			<!-- Host-provided buttons, pinned to the right end of the filter row -->
			<div class="flex items-center py-2 px-1">
				<slot name="filter-actions"></slot>
			</div>
			<br />
		</div>
		<!-- SUB TEXT FORMAT -->
		<div v-if="$props.subtext" class="th-sticky" style="color: #a9a9a9">
			{{ $props.subtext }}
		</div>
		<div v-else>
			<div v-if="showRowNum && !$props.isGestion">
				<h7 class="th-sticky" style="color: #a9a9a9"
					>Résultat total: {{ filterRowNum }} / {{ $props.showListLength }}</h7
				>
			</div>
			<div v-if="showRowNum && $props.isGestion">
				<h7 class="th-sticky" style="color: #a9a9a9"
					>Résultat total: {{ $props.showListLength }}</h7
				>
			</div>
		</div>
		<!-- SUB TEXT FORMAT -->
	</vx-card>
</template>

<script>
import $ from "jquery";
import VueCookies from "vue-cookies";
import store from "@/store/store";
import flatPickr from "vue-flatpickr-component";
// import { SetupCalendar, Calendar, DatePicker } from 'v-calendar';
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/plugins/monthSelect/style.css";
import { VueTags } from "vue-tags-component";
import moment from "moment";
import { MonthPickerInput } from "vue-month-picker";
import { Backlinks } from "../../entities/Backlinks";
import ProspectSearch from "../../entities/ProspectSearch";
import VxTooltip from "../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "FilterCard",
	components: {
		MonthPickerInput,
		flatPickr,
		VueTags,
	},
	mixins: [dbFieldConvertorMixin],

	props: {
		isFilterButton: {
			// Add the button "Filtres" if true
			type: Boolean,
			default: true,
		},
		del: {
			type: Boolean,
			default: true,
		},
		showRowNum: {
			type: Boolean,
			default: true,
		},
		showListLength: {
			type: Number,
			default: 0,
		},
		subtext: {
			type: String,
			default: null,
		},
		isOpen: {
			// Add the button "Rechercher" if true to validate the changes
			type: Boolean,
			default: true,
		},
		refreshKey: Number,
		onChangeEmit: {
			// Add the button "Rechercher" if true to validate the changes
			type: Boolean,
			default: false,
		},
		isGestion: {
			type: Boolean,
			default: false,
		},
		open: {
			type: Boolean,
			default: false,
		},
		/**
		 * Show the status of Rankwell data work load in the filter card
		 */
		showProspectStatus: {
			type: Boolean,
			default: false,
		},
		/**
		 * Show arrow buttons on both sides of period picker for navigation
		 */
		showPeriodArrows: {
			type: Boolean,
			default: false,
		},
		/**
		 * filter template example:
		 * {
		 * 	order: 4 // Filter order compared to others
		 * 	emitSlugName: "filter_start_date",
		 *	filterPlaceHolder: "Date de début"
		 * 	value: "2022-01-01",
		 * 	type: "Date",
		 * 	params: {
		 * 		date_limit: "start_date",
		 * 		date_type: "period"
		 * 	}
		 * }
		 * {
		 * 	order: 1 // Filter order compared to others
		 * 	emitSlugName: "filter_lead_consultant",
		 *	filterPlaceHolder: "Lead Consultant"
		 * 	value: 141, // Consultant id
		 * 	type: "Dropdown",
		 * 	params: {
		 * 		autocomplete: false, // Activates autocomplete by writing
		 * 		multiple: false, // Acticates multiple selection
		 * 		dropdownValues: [
		 * 			{
		 * 				name: "David Degobert",
		 * 				id: 2
		 * 			}
		 * 		]
		 * 	}
		 * }
		 */
		filters: {
			type: Array,
			default: [],
		},
		/**
		 * action template:
		 * {
		 *	order: 1
		 * 	emitSlugName: "action_update_contract",
		 * 	buttonName: "Modifier",
		 * 	buttonIcon: "plus_icon"
		 * 	buttonColor: "dark",
		 * 	params: {
		 * 		contract_id: "719",
		 * 	}
		 * }
		 */
		actions: {
			type: Array,
			default: [],
		},
	},
	data() {
		return {
			/**
			 * emit template:
			 * {
			 * 	emitSlugName: "filter_start_date"
			 * 	params: {
			 * 		start_date: "2022-10-10"
			 * 	}
			 * }
			 */
			thisMonth: parseInt(moment().format("MM")),
			thisYear: parseInt(moment().format("YYYY")),
			backlinksSortType: Backlinks.getSortList(),
			sortBacklinks: false,
			date: {
				from: null,
				to: null,
				month: null,
				year: null,
			},
			maxDate: new Date("2023-12-31"),
			datePickerKey: 0,
			refreshList: [],
			emitLayer: [],
			showFilters: this.$props.isOpen,
			filtersValues: [],
			configDatePicker: {
				dateFormat: "j/n/Y",
			},
			configPeriodPicker: {
				prevArrow: "",
				allowInput: true,
				nextArrow: "",
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
			tagStyle: "z-index: 1600 !important;",
			// Rankwell Data
			workLoad: null,
		};
	},

	created() {
		let clearFunc = this.dateClear;
		this.refreshList = [...this.filters];
		this.filtersValues = [...this.filters];
		console.log(this.filters);
		this.showFilters = this.$props.isOpen ? true : false;
		this.maxDate = new Date(moment().format("YYYY-MM-DD"));
		const filtersBackIndex = this.$props.filters.find(
			(ele) => ele.type == "BacklinkSort"
		);
		if (filtersBackIndex) {
			this.sortBacklinks = filtersBackIndex;
		}
		$(document).ready(function () {
			let delBox = $(".deleteicon");
			let run = delBox.length > 0 ? true : false;
			if (!run) {
				$(".month-picker-input")
					.wrap('<span class="deleteicon"></span>')
					.after(
						$("<span class ='clearMonth'>x</span>").click(function () {
							clearFunc();
							$(this).prev("input").val("").trigger("change").focus();
						})
					);
			}
			//toreload screen duplicate is required
			$(".clearMonth").click(function () {
				clearFunc();
				$(this).prev("input").val("").trigger("change").focus();
			});
			/*
			 * document.getElementsByClassName("month-picker-clear-btn").addEventListener("click", function(){
			 * 	clearFunc();
			 * 	$(this).prev("input").val("").trigger("change").focus();
			 * });
			 */
		});
		if (this.showProspectStatus) this.getRankwellDataStatus();
	},
	mounted() {
		store.dispatch(
			"updateFilterCardHeight",
			document.getElementById("fliterCard").clientHeight
		);
		//console.log("mounted FILTER");
		//console.log(document.getElementById("fliterCard").clientHeight);
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				store.dispatch(
					"updateFilterCardHeight",
					document.getElementById("fliterCard").clientHeight
				);
			});
		});
		/*
		 * removing arrow button in datepicker
		 *  $(".flatpickr-prev-month").remove();
		 *  $(".flatpickr-next-month").remove();
		 */
	},
	updated() {
		store.dispatch("updateFilterDown", this.showFilters);
		store.dispatch(
			"updateFilterCardHeight",
			document.getElementById("fliterCard").clientHeight
		);
		let clearFunc = this.dateClear;
		$(document).ready(function () {
			let delBox = $(".deleteicon");
			let run = delBox.length > 0 ? true : false;
			if (!run) {
				$(".month-picker-input")
					.wrap('<span class="deleteicon"></span>')
					.after(
						$("<span class ='clearMonth'>x</span>").click(function () {
							clearFunc();
							$(this).prev("input").val("").trigger("change").focus();
						})
					);
			}
			//toreload screen duplicate is required
			$(".clearMonth").click(function () {
				clearFunc();
				$(this).prev("input").val("").trigger("change").focus();
			});
			/*
			 * document.getElementsByClassName("month-picker-clear-btn").addEventListener("click", function(){
			 * 	clearFunc();
			 * 	$(this).prev("input").val("").trigger("change").focus();
			 * });
			 */
		});
	},
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		filterRowNum: () => {
			return store.state.filterRowNum;
		},
		listResult: () => {
			return store.state.contracts_contracts_users;
		},
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		isCurrentPeriod() {
			// Check if the selected period is the current actual period
			const currentMonth = parseInt(moment().format("MM"));
			const currentYear = parseInt(moment().format("YYYY"));
			return this.thisMonth === currentMonth && this.thisYear === currentYear;
		},
	},
	watch: {
		showListLength: function (data) {
			if (data == 0) this.setRowNum(0);
		},
		filters: function (data) {
			this.filtersValues = [...data];
			//console.log("filters", this.filtersValues);
		},
		open: function (data) {
			this.showFilters = data ? true : false;
		},
		/*
		 * "filterFields.start_date": {
		 * 	deep: true,
		 * 	handler(data) {
		 * 		this.filterFields.end_date = data;
		 * 	}
		 * },
		 */
	},
	methods: {
		showDate(date) {
			let sendDate = date.monthIndex.toString() + "/" + date.year.toString();
			let sendDate2 = moment(date.from).format("MM/YYYY");
			this.handleEmitEvent("filter", {
				emitSlugName: "filter_period",
				params: { value: sendDate2 },
			});

			this.date = date;

			// ✅ Sync thisMonth and thisYear with manually selected period
			// This ensures arrow buttons work correctly after manual selection
			this.thisMonth = date.monthIndex + 1; // monthIndex is 0-based, thisMonth is 1-based
			this.thisYear = date.year;
		},
		gotoPreviousMonth() {
			// Navigate to previous month
			let currentMonth = this.thisMonth;
			let currentYear = this.thisYear;

			if (currentMonth === 1) {
				// If January, go to December of previous year
				this.thisMonth = 12;
				this.thisYear = currentYear - 1;
			} else {
				this.thisMonth = currentMonth - 1;
			}

			// Force re-render the date picker
			this.datePickerKey++;

			// Trigger the date change event
			this.$nextTick(() => {
				const newDate = moment()
					.year(this.thisYear)
					.month(this.thisMonth - 1)
					.format("MM/YYYY");

				this.handleEmitEvent("filter", {
					emitSlugName: "filter_period",
					params: { value: newDate },
				});
			});
		},
		gotoNextMonth() {
			// Navigate to next month
			let currentMonth = this.thisMonth;
			let currentYear = this.thisYear;

			if (currentMonth === 12) {
				// If December, go to January of next year
				this.thisMonth = 1;
				this.thisYear = currentYear + 1;
			} else {
				this.thisMonth = currentMonth + 1;
			}

			// Force re-render the date picker
			this.datePickerKey++;

			// Trigger the date change event
			this.$nextTick(() => {
				const newDate = moment()
					.year(this.thisYear)
					.month(this.thisMonth - 1)
					.format("MM/YYYY");

				this.handleEmitEvent("filter", {
					emitSlugName: "filter_period",
					params: { value: newDate },
				});
			});
		},
		dateClear() {
			this.handleEmitEvent("filter", {
				emitSlugName: "filter_period",
				params: { value: null },
			});
		},
		clearAll() {
			this.refreshList.forEach((ele) => {
				ele.value = "";
				if (ele.emitSlugName == "filter_tag") {
					ele.params.domainFilter = [];
					ele.params.activityDomainOptions = [];
				}
			});
			this.filters = this.refreshList;
			this.datePickerKey++;
			this.$emit("clearAll", 0);
		},
		toogleFilter() {
			this.showFilters = !this.showFilters;
		},
		setRowNum(len) {
			store.dispatch("setRowNum", len);
		},
		emitEvent(type, event) {
			//console.log("emitEvent", event);
			this.$emit(type, [event.emitSlugName, event.params]);
		},
		sendEmitLayer() {
			try {
				while (this.emitLayer.length > 0) {
					let emitEvent = this.emitLayer.pop();
					this.emitEvent(emitEvent[0], emitEvent[1]);
				}
			} catch (e) {
				console.error(e);
			}
		},
		handleEmitEvent(type, event) {
			if (this.onChangeEmit) this.emitEvent(type, event);
			else this.emitLayer.push([type, event]);
		},
		cleanAllFilters() {
			//console.log("TODO");
		},

		onTagAdded(tag, filter) {
			if (filter.params.domainFilter.indexOf(tag) < 0)
				filter.params.domainFilter.push(tag);
		},

		onTagRemoved(tag, filter) {
			filter.params.domainFilter.splice(
				filter.params.domainFilter.indexOf(tag),
				1
			);
		},
		async getRankwellDataStatus() {
			try {
				const response = await ProspectSearch.getRankwellDataStatus();
				this.workLoad = response;
			} catch (e) {
				this.workLoad = null;
			}
		},
		formattedWorkLoad() {
			return `
        AT / WT : ${this.workLoad.activeCount} / ${this.workLoad.waitingCount}      
      `;
			//   Delayed Tasks: ${this.workLoad.delayedCount} /
			//   Completed Tasks: ${this.workLoad.completedCount} /
			//   Failed Tasks: ${this.workLoad.failedCount} /
		},
	},
};
</script>
<style lang="scss">
.month-picker-input-container {
	width: 100% !important;
}
.btn {
	background-color: white !important;
	border: none;
	border: 1px solid #08b0b9 !important;
	color: #08b0b9;
	padding: 12px 12px;

	cursor: pointer;
}
.btn:hover {
	box-shadow: 0px 15px 20px rgba(255, 255, 255, 0.945) !important;
}
.clear-btn {
	background-color: white;
	color: red;
	border: 0;

	cursor: pointer;
}
.clear-btn:hover {
	padding-top: 5px;
	transition-duration: 0.2s;
}
/* Darker background on mouse-over */
.month-picker__container {
	z-index: 999;
}

.tag {
	height: auto !important;
	background-color: rgb(180, 180, 180) !important;
}
.tags {
	height: 32px !important;
}
.tag-filter > .tags__shadow > .tags__active {
	border-radius: 5px 5px 5px 5px !important;
}
.tags__active {
	padding: 2px 0 0 2px !important;
	border-radius: 5px 5px 5px 5px !important;
	min-height: 32px !important;
}
.tags__list {
	display: grid !important;
	max-height: 300px !important;
	overflow: auto !important;
}
.tags__list-item {
	min-height: auto !important;
	margin-bottom: 1px;
	padding: 0 5px 0 5px !important;
}
.tags__list-item-tag {
	height: auto !important;
	align-self: center;
	background-color: rgb(180, 180, 180) !important;
}
.tags__search {
	border: none;
}
.table-filter {
	.con-tablex.vs-table--content {
		.vs-con-tbody.vs-table--tbody > table {
			display: flex;
			flex-wrap: wrap;
			background: white;
			thead {
				display: none;
			}
			tr {
				.td-check {
					width: 40px;
				}
				td {
					border: none;
				}
			}
			.tr-expand > td > div {
				border: none;
				padding: 10px 20px 10px 20px;
			}
			.not-data-table {
				display: none;
			}
		}
		.not-data-table.vs-table--not-data {
			display: none;
		}
	}
}
span.deleteicon {
	position: relative;
	display: inline-flex;
	align-items: center;
}
span.deleteicon span {
	position: absolute;
	display: block;
	right: 3px;
	width: 15px;
	height: 15px;
	border-radius: 50%;
	color: #fff;
	background-color: #ccc;
	font: 13px monospace;
	text-align: center;
	line-height: 1em;
	cursor: pointer;
}
span.deleteicon input {
	padding-right: 18px;
	box-sizing: border-box;
}
</style>